/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { FieldError, FieldErrors, FieldValues } from 'react-hook-form';

export const getNestedFormError = (errors: FieldErrors<FieldValues>, path: string): FieldError | undefined => {
  return path.split('.').reduce((acc: any, part: string) => {
    return acc?.[part];
  }, errors);
};
